// Additional columns kept on the product record but not shown in Import Hub
// views or exports: internal document-upload metadata, plus the MPF amount
// carried over from an uploaded entry summary (MPF is excluded from Import Hub).
// Matched case-insensitively with `_` treated as a space.
const HIDDEN_ADDITIONAL_COLUMN_KEYS = new Set([
  'screening context',
  'source file storage key',
  'special program tariffs',
  'mpf amount',
]);

export const isHiddenAdditionalColumn = (key: string): boolean =>
  HIDDEN_ADDITIONAL_COLUMN_KEYS.has(
    key.trim().toLowerCase().replace(/_/g, ' '),
  );
